module.exports = __webpack_public_path__ + "img/2.adf64dbd.png";